(function () {
  let lastCollectionAdd = null;
  let bridgePatched = false;

  function getFormQuantity(form) {
    if (!form) return 1;

    const hiddenQty = form.querySelector('.card-quantity-hidden[name="quantity"]');
    const visibleQty = form.querySelector('.qty-product .qty-input');
    const raw =
      (hiddenQty && hiddenQty.value) ||
      (visibleQty && visibleQty.value) ||
      1;

    const qty = parseInt(raw, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function getFormVariantId(form) {
    if (!form) return null;
    const idEl = form.querySelector('input[name="id"], select[name="id"]');
    return idEl ? String(idEl.value) : null;
  }

  function rememberFormIntent(form) {
    if (!form) return;

    lastCollectionAdd = {
      form: form,
      id: getFormVariantId(form),
      quantity: getFormQuantity(form),
      ts: Date.now()
    };
  }

  function getRecentIntent() {
    if (!lastCollectionAdd) return null;
    if (Date.now() - lastCollectionAdd.ts > 4000) return null;
    return lastCollectionAdd;
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function patchBody(body, intent) {
    if (!intent) return body;

    const desiredQty = String(intent.quantity);
    const desiredId = intent.id ? String(intent.id) : null;

    if (body instanceof FormData) {
      body.set('quantity', desiredQty);
      if (desiredId) body.set('id', desiredId);
      return body;
    }

    if (body instanceof URLSearchParams) {
      body.set('quantity', desiredQty);
      if (desiredId) body.set('id', desiredId);
      return body;
    }

    if (typeof body === 'string') {
      const trimmed = body.trim();

      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmed);

          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            parsed.quantity = intent.quantity;
            if (desiredId) parsed.id = desiredId;
            return JSON.stringify(parsed);
          }
        } catch (e) {}
      }

      try {
        const params = new URLSearchParams(body);
        params.set('quantity', desiredQty);
        if (desiredId) params.set('id', desiredId);
        return params.toString();
      } catch (e) {
        return body;
      }
    }

    return body;
  }

  function patchFetch() {
    const originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function (input, init) {
      try {
        const url = typeof input === 'string' ? input : (input && input.url);
        const intent = getRecentIntent();

        if (intent && isCartAddUrl(url)) {
          if (init && typeof init === 'object') {
            init = Object.assign({}, init);
            init.body = patchBody(init.body, intent);
          }
        }
      } catch (e) {
        console.warn('qty-chooser fetch patch error', e);
      }

      return originalFetch.call(this, input, init);
    };
  }

  function patchXHR() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartAddUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        const intent = getRecentIntent();

        if (intent && isCartAddUrl(this.__cartAddUrl)) {
          body = patchBody(body, intent);
        }
      } catch (e) {
        console.warn('qty-chooser xhr patch error', e);
      }

      return originalSend.call(this, body);
    };
  }

  function bindCollectionForms(root) {
    const scope = root || document;

    scope.querySelectorAll('form.custom-card-form-wrap').forEach(function (form) {
      if (form.dataset.qtyBridgeInit === 'true') return;
      form.dataset.qtyBridgeInit = 'true';

      const addBtn = form.querySelector('.custom-card-add-btn, [type="submit"]');
      if (!addBtn) return;

      ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (evt) {
        addBtn.addEventListener('add-' + evt, function(){});
        addBtn.addEventListener(evt, function () {
          rememberFormIntent(form);
        }, { capture: true, passive: true });
      });

      form.addEventListener('submit', function () {
        rememberFormIntent(form);
      }, true);
    });
  }

  function ensureBridgePatched() {
    if (bridgePatched) return;
    bridgePatched = true;
    patchFetch();
    patchXHR();
  }

  function initQtyWidget(widget) {
    if (!widget || widget.dataset.qtyInit === 'true') return;
    widget.dataset.qtyInit = 'true';

    const form = widget.closest('form');
    if (!form) return;

    const wrapper = widget.querySelector('.qty-input-wrapper');
    const input = widget.querySelector('.qty-input');
    const grid = widget.querySelector('.qty-grid');
    const errorEl = widget.querySelector('.qty-error');
    const altroBtn = widget.querySelector('.qty-altro');
    const addBtn = form.querySelector('.custom-card-add-btn, [type="submit"]');
    const formQtyInput = form.querySelector('.card-quantity-hidden[name="quantity"]');

    if (!wrapper || !input || !grid || !errorEl || !altroBtn || !formQtyInput) return;

    let inventory = parseInt(widget.dataset.inventory, 10) || 0;
    let variants = [];
    let manualMode = false;

    try {
      variants = JSON.parse(widget.dataset.variants || '[]');
    } catch (e) {
      variants = [];
    }

    function normalizeQty(val) {
      let parsed = parseInt(val, 10);

      if (isNaN(parsed) || parsed < 1) parsed = 1;
      if (inventory > 0 && parsed > inventory) parsed = inventory;

      return parsed;
    }

    function syncFormQuantity(val) {
      const qty = normalizeQty(val);
      input.value = qty;
      formQtyInput.value = qty;
      return qty;
    }

    function closeGrid() {
      grid.classList.remove('open');
      widget.classList.remove('qty-open');
    }

    function openGrid() {
      grid.classList.add('open');
      widget.classList.add('qty-open');
    }

    function enableManualImmediate() {
      manualMode = true;
      wrapper.classList.add('activated');
      input.removeAttribute('readonly');
      input.value = '';
      input.placeholder = '';
      errorEl.style.display = 'none';
      closeGrid();
      input.focus();
      try {
        input.setSelectionRange(0, 0);
      } catch (e) {}
    }

    function clearSelectedOptions() {
      widget.querySelectorAll('.qty-option.selected').forEach(function (o) {
        o.classList.remove('selected');
      });
    }

    function handleManualInput() {
      if (!manualMode) return;

      const val = parseInt(input.value, 10);
      errorEl.style.display = 'none';
      clearSelectedOptions();

      if (isNaN(val) || val < 1) {
        return;
      }

      if (val > inventory) {
        syncFormQuantity(inventory);
        errorEl.textContent = "Quantità massima disponibile: " + inventory;
        errorEl.style.display = 'block';
        return;
      }

      syncFormQuantity(val);

      const match = widget.querySelector('.qty-option[data-value="' + val + '"]:not(.disabled)');
      if (match) match.classList.add('selected');
    }

    syncFormQuantity(input.value || widget.dataset.placeholder || 1);

    ['click', 'touchstart'].forEach(function (evt) {
      wrapper.addEventListener(evt, function (e) {
        if (manualMode) return;
        e.preventDefault();
        e.stopPropagation();

        if (grid.classList.contains('open')) {
          closeGrid();
        } else {
          openGrid();
        }
      }, { passive: false });
    });

    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target)) {
        closeGrid();

        if (manualMode) {
          input.setAttribute('readonly', '');
          wrapper.classList.remove('activated');
          manualMode = false;

          const currentVal = parseInt(input.value, 10);
          if (!isNaN(currentVal) && currentVal >= 1) {
            syncFormQuantity(currentVal);
          } else {
            syncFormQuantity(widget.dataset.placeholder || 1);
          }
        }

        errorEl.style.display = 'none';
      }
    });

    grid.addEventListener('click', function (e) {
      e.stopPropagation();
      const btn = e.target.closest('button');
      if (!btn) return;

      if (btn.classList.contains('qty-altro')) {
        if (btn.disabled) return;
        enableManualImmediate();
        return;
      }

      if (btn.classList.contains('qty-option') && !btn.disabled) {
        const val = parseInt(btn.dataset.value, 10);

        syncFormQuantity(val);
        errorEl.style.display = 'none';

        widget.querySelectorAll('.qty-option').forEach(function (o) {
          o.classList.toggle('selected', parseInt(o.dataset.value, 10) === val);
        });

        closeGrid();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    altroBtn.addEventListener('touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (altroBtn.disabled) return;
      enableManualImmediate();
    }, { passive: false });

    ['input', 'change', 'blur'].forEach(function (evt) {
      input.addEventListener(evt, handleManualInput);
    });

    if (addBtn) {
      ['click', 'touchstart'].forEach(function (evt) {
        addBtn.addEventListener(evt, function () {
          syncFormQuantity(input.value || widget.dataset.placeholder || 1);
        }, { passive: true });
      });
    }

    form.addEventListener('submit', function () {
      syncFormQuantity(input.value || widget.dataset.placeholder || 1);
    });

    const variantInput = form.querySelector('input[name="id"], select[name="id"]');

    if (variantInput) {
      variantInput.addEventListener('change', function (e) {
        const newId = e.target.value;
        const rec = variants.find(function (x) {
          return String(x.id) === String(newId);
        });

        if (!rec) return;

        manualMode = false;
        wrapper.classList.remove('activated');
        input.setAttribute('readonly', '');

        inventory = parseInt(rec.inventory_quantity, 10) || 0;

        let ph = 1;
        if (inventory < ph) ph = inventory;
        if (inventory <= 0) ph = 0;

        widget.dataset.inventory = inventory;
        widget.dataset.placeholder = ph;

        input.max = inventory;
        input.placeholder = ph;
        syncFormQuantity(ph);

        errorEl.style.display = 'none';

        widget.querySelectorAll('.qty-option').forEach(function (o) {
          const num = parseInt(o.dataset.value, 10);
          o.disabled = num > inventory;
          o.classList.toggle('disabled', num > inventory);
          o.classList.toggle('selected', num === ph);
        });

        if (inventory <= 0) {
          altroBtn.disabled = true;
          altroBtn.classList.add('disabled');
        } else {
          altroBtn.disabled = false;
          altroBtn.classList.remove('disabled');
        }
      });
    }
  }

  function initAllQtyWidgets(root) {
    (root || document).querySelectorAll('.qty-product').forEach(initQtyWidget);
  }

  function initCollectionQtySystem(root) {
    ensureBridgePatched();
    initAllQtyWidgets(root || document);
    bindCollectionForms(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionQtySystem(document);
  });

  window.initAllQtyWidgets = initAllQtyWidgets;
  window.initCollectionQtySystem = initCollectionQtySystem;
})();